import { AccessTime, Delete } from "@mui/icons-material";
import { FormHelperText, IconButton, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { StyledAppointmentsSessionCard } from "../../../../../styled/appointments";

const AppointmentSessionCards = ({
  data,
  onDelete,
  setTraslado,
  handleChangeDate,
  handleSetDisableSave,
  errors,
}) => {
  return (
    <StyledAppointmentsSessionCard.Container>
      <StyledAppointmentsSessionCard.TitleContainer>
        <StyledAppointmentsSessionCard.Title variant="body2">
          TURNOS
        </StyledAppointmentsSessionCard.Title>
      </StyledAppointmentsSessionCard.TitleContainer>
      <StyledAppointmentsSessionCard.AppointmentContainer>
        {data.length === 0 ? (
          <StyledAppointmentsSessionCard.EmptyState>
            <Typography variant="body2">No hay turnos para agregar</Typography>
          </StyledAppointmentsSessionCard.EmptyState>
        ) : (
          data.map((appointment, index) => (
            <StyledAppointmentsSessionCard.Card key={appointment.fechaHora}>
              <StyledAppointmentsSessionCard.ContentContainer>
                <Typography variant="body2">
                  {moment(appointment.fechaHora).format("DD/MM/YYYY")}
                </Typography>
                <StyledAppointmentsSessionCard.TimePickerStyled
                  value={appointment.fechaHora} // Vincula directamente el valor del turno
                  name="hora"
                  label="Hora Turno"
                  variant="inline"
                  autoOk={true}
                  timeSteps={{ minutes: 1 }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                    },
                  }}
                  ampm={false}
                  keyboardIcon={<AccessTime />}
                  onChange={(value) => {
                    if (value != null && value != "Invalid Date") {
                      const updatedDate = moment(appointment.fechaHora)
                        .hour(moment(value).hour())
                        .minute(moment(value).minute())
                        .toDate();

                      handleChangeDate(index, updatedDate);
                      handleSetDisableSave(false);
                    } else {
                      handleSetDisableSave(true);
                    }
                  }}
                />
                {errors?.[`appointments[${index}]`] ? (
                  <FormHelperText error>
                    {errors?.[`appointments[${index}]`]}
                  </FormHelperText>
                ) : null}
              </StyledAppointmentsSessionCard.ContentContainer>
              <StyledAppointmentsSessionCard.ActionsContainer>
                <Tooltip title="Traslado">
                  <IconButton>
                    <StyledAppointmentsSessionCard.CarIcon
                      traslado={appointment.traslado}
                      onClick={() => setTraslado(appointment)}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar">
                  <IconButton color="inherit">
                    <Delete onClick={() => onDelete(appointment)} />
                  </IconButton>
                </Tooltip>
              </StyledAppointmentsSessionCard.ActionsContainer>
            </StyledAppointmentsSessionCard.Card>
          ))
        )}
      </StyledAppointmentsSessionCard.AppointmentContainer>
    </StyledAppointmentsSessionCard.Container>
  );
};

export default AppointmentSessionCards;
